/**
 * Created by Administrador on 16/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('classificationService', classificationService)

    classificationService.$inject = ['$http', 'CONFIG', 'messageService'];

    function classificationService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CARGO_CONTROL + '/' + CONFIG.API + '/classifications';
        var service = {
            getClassifications: getClassifications,
            getClassificationList: getClassificationList,
            getClassification: getClassification,
            saveClassification: saveClassification,
            updateClassification: updateClassification,
            deleteClassification: deleteClassification
        }

        return service;

        function getClassifications(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getClassificationList(){
            return $http.get(urlBase + '/list')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getClassification(id){
            return $http.get(urlBase + "/" + id )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('classifications')
                });
        }

        function saveClassification(classification){
            return $http.post(urlBase, classification)
                .then(function(response){
                    messageService.register('classifications');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('classifications')
                });
        }

        function updateClassification(classificationId, classification){
            return $http.put(urlBase + "/" + classificationId, classification)
                .then(function(response){
                    messageService.registerUpdate('classifications')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('classifications')
                });
        }

        function deleteClassification(classificationId){
            return $http.delete(urlBase + "/" + classificationId)
                .then(function(response){
                    messageService.registerDelete('classifications');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('classifications');
                });
        }
    }
})();
